<template>
  <footer>
    <div id="fb-root"></div>
    <p>{{footerInfo}}</p>
    <div class="footer-right text-right">
      <span>Obserwuj nas na:</span>
      <a href="https://www.facebook.com/mDomMaklerski.Polska" target="_blank">
        <img src="images/social/facebook.svg" alt="FB" />
      </a>
      <a href="https://twitter.com/BMmBanku" target="_blank">
        <img src="images/social/twitter.svg" alt="Twitter" />
      </a>
      <a href="https://www.youtube.com/user/mDomMaklerski" target="_blank">
        <img src="images/social/youtube.svg" alt="Youtube" />
      </a>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      // eslint-disable-next-line
      footerInfo: FOOTER_TXT
    };
  }
};
</script>


<style scoped>
footer {
  background-color: #fff;
  color: #525447;
  font-size: 12px;
  padding: 35px 17px 15px;
  font-weight: 100;
  line-height: 130%;

}

.footer-left {
  width: 50%;
  float: left;
  filter: grayscale(100%);
  opacity: 0.8;
}

.footer-right {
  width: 50%;
  float: right;
  text-align: right;
}

.footer-right span {
  vertical-align: bottom;
  font-size: 10px;
  margin-right: 10px;
}

.footer-right a {
  margin-right: 10px;
}

.footer-right a:last-child {
  margin-right: 0;
}

iframe {
  border: 1px solid red !important;
}

iframe body {
  background: red !important;
}

.fb-like {
  max-width: 100%;
}
@media (max-width: 1500px) {
  footer {
    margin: 0px;
    width: 100%;
  }
}
@media (min-width: 1024px){
 footer{
   padding: 35px 5% 15px;
   height: 130px;
 }
}

@media (max-width: 1023px) {
  .footer-left,
  .footer-right {
    float: none;
    width: 100%;
    text-align: center !important;
  }

  .footer-left,
  .footer-right span {
    display: block;
    margin: 10px;
  }
}
</style>




